<div #contextualMenu class="menu" *ngIf="mpContextualMenu">
  <ng-container [ngTemplateOutlet]="mpContextualMenu"
    [ngTemplateOutletContext]="{$implicit: mpContextualMenuData}"></ng-container>
</div>
